const constants = {
    CHANGE_LANG: "CHANGE_LANG",
    CHANGE_AUTHORIZED: "CHANGE_AUTHORIZED",

    ADD_USER_TO_STORAGE: "ADD_USER_TO_STORAGE",
    DELETE_USER_FROM_STORAGE: "DELETE_USER_FROM_STORAGE",

    START_LOADING_USER: "START_LOADING_USER",
    FAIL_LOADING: "FAIL_LOADING",
    USER_REGISTERED: "USER_REGISTERED",

    UPDATE_RATING: "UPDATING_RATING",

};

export default constants;


export const languages = {
    RUS: "RUS",
    ENG: "ENG",
};

export const tabChamp = {
    OVERVIEW: "OVERVIEW",
    DATA: "DATA",
    ALGORITHM: "ALGORITHM",
    RATING: "RATING",
    MY_TEAM: "TEAM",
    METRIC :"METRIC",
    SOLUTIONS: "SOLUTIONS",
    TEAM: "TEAM",
    TAKEPART: "TAKEPART",
};

export const urlNameChamp = {
    OVERVIEW: "overview",
    DATA: "data",
    ALGORITHM: "algorithm",
    RATING: "rating",
    MY_TEAM: "team",
    METRIC :"metric",
    SOLUTIONS: "solutions",
    TAKEPART: "takepart",
    TEAM_MANAGEMENT: "team_management"
};

export const tabSettings = {
    NICKNAME: "NICKNAME",
    EMAIL: "EMAIL",
    PHONE: "PHONE",
    DATA: "DATA",
    PASSWORD: "PASSWORD",
    LOGIN: "LOGIN",
};

export const champType = {
    ALL: "ALL",
    ACTIVE: "ACTIVE",
    INFINITY: "INFINITY",
    ENDED: "ENDED",
};


export const tabRating = {
    RATING: "RATING",
    FORMULA: "FORMULA",
    MEDALS: "MEDALS"
};

export const tabAdmin = {
    CHAMPS: "CHAMPS",
    USERS: "USERS",
    BACKUP: "BACKUP",
    VACANCY: "VACANCY",
    FORUM: "FORUM",
};

export const NotificationType = {

    type : {
        TOP_3: "TOP_3",
        TOP_20: "TOP_20",
        TOP_50: "TOP_50",
        TOP_100: "TOP_100",
        TOP_N: "TOP_N",
        TO_ALL: "TO_ALL",
    },
    TOP_3: {
        text: "Топ - 3",
        num: 3,
    },
    TOP_20: {
        text: "Топ - 20",
        num: 20,
    },
    TOP_50: {
        text: "Топ - 50",
        num: 50,
    },
    TOP_100: {
        text: "Топ - 100",
        num: 100,
    },
    TOP_N: {
        text: "Топ - N",
        num: 1,
    },
    TO_ALL: {
        text: "Всем участникам чемпионата",
        num: "1000000"
    }
};


export const BackupType = {
    type : {
        ALL: "ALL",
        CHAMP: "CHAMP",
        PHONE: "PHONE",
        EMAIL:"EMAIL",
        IMPORT_USERS: "IMPORT_USERS"
    },

    CHAMP: "Данные чемпионата",
    ALL: "Всех участников",
    PHONE: "Телефоны участников",
    EMAIL:"Почты участников",
    IMPORT_USERS: "Импорт пользователей из файла"
};

export const SearchType = {
    type : {
        LOGIN: "LOGIN",
        NAME: "NAME",
        NICK: "NICK",
        PHONE: "PHONE",
        EMAIL:"EMAIL",
        CITY: "CITY"
    },

    LOGIN: "Логин",
    NAME: "Имя Фамилия",
    NICK: "Ник",
    PHONE: "Телефон",
    EMAIL:"Почта",
    CITY: "Город"

};



// WEBPACK FOOTER //
// src/constants/index.jsx